
<template>
    <section class="col-12">
        <label><strong>Insurance Documents</strong></label>
        <div class="table table-responsive">
            <vue-good-table v-if="!loading"
                id="table-insurance_documents"
                ref="table-insurance_documents"
                :select-options="{ enabled: true, selectOnCheckboxOnly: true, }"
                :search-options="{ enabled: true }"
                @on-selected-rows-change="selectionChanged"
                :sort-options="{
                    enabled: true,
                    initialSortBy: {field: columns[0].field, type: 'asc'}
                  }"
                :columns="columns"
                :rows="rows">
                <div slot="table-actions">
                    <div class="btn-group">
                        <button v-if="actionsLocal.add" type="button" title="Find" @click.prevent="() => {$refs.insuranceDocumentModal.getData()}" data-toggle="modal"
                                data-target="#insuranceDocumentsModal"
                                data-backdrop="static"
                                data-keyboard="false" class="btn btn-info" style="font-size: 10px;"><i
                            class="fa fa-search"></i>
                        </button>
                        <button v-if="actionsLocal.remove" type="button" @click="removeInsuranceDocument"
                                class="btn  btn-danger"
                                title="Delete"
                                style="font-size: 10px;"><i class="fa fa-trash"></i>
                        </button>
                        <button v-if="actionsLocal.reset" type="button" @click="removeColumnsStore"
                                class="btn  btn-warning" title="Reset"
                                style="font-size: 10px;"><i class="fa fa-undo"></i>
                        </button>
                        <button v-if="actionsLocal.file" type="button" @click="exportExcel" class="btn  btn-success"
                                title="Export Excel"
                                style="font-size: 10px;"><i class="fas fa-file-excel"></i>
                        </button>
                        <button v-if="actionsLocal.columns" type="button" data-toggle="modal"
                                data-target="#columnsInsuranceDocumentModal" data-backdrop="static"
                                title="Customize View"
                                data-keyboard="false" class="btn btn-secondary" style="font-size: 10px;"><i
                            class="fa fa-list"></i>
                        </button>
                    </div>
                </div>
                <template slot="table-row" slot-scope="props">
                   <span v-if="props.column.field === 'custom_field'">

                   </span>
                    <span v-else-if="props.column.field === 'actions'">
                       <slot name="actions" :props="props" :columns="columns"></slot>
                   </span>
                    <span v-else> {{ props.formattedRow[props.column.field] }}</span>
                </template>
            </vue-good-table>
            <!-- Modal -->
            <div class="modal fade" id="insuranceDocumentsModal" tabindex="-1" role="dialog"
                 aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-xl" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Find Contact Type</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" style="max-height: 400px; overflow-y: scroll;">
                            <generic-select ref="insuranceDocumentModal" @selecteds="setSelecteds"
                                            model="App\Models\InsuranceDocument"></generic-select>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-primary" @click="addInsuranceDocument">Done</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="columnsInsuranceDocumentModal" tabindex="-1" role="dialog"
                 aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Columns - Show/Hide</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" style="max-height: 400px; overflow-y: scroll;">
                            <div class="row">
                                <div v-for="(column, index) in columns" :key="index" class="col-md-4"
                                     style="border-bottom: 1px solid #DDDDDD">
                                    <a href="#" @click.prevent="setStatusColumn(column)" class="small"
                                       tabIndex="-1">
                                        <span v-if="column.hidden" class="fa fa-eye-slash"></span>
                                        <span v-else class="fa fa-eye text-info"></span>
                                        &nbsp;{{ column.label }}</a>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
            <input v-for="row in rows" type="hidden" :name="name+'[]'" :key="row.id" :value="row.id">
        </div>
    </section>
</template>

<script>
import _ from "lodash";
import {URL_BASE} from "../../../utils/helper";
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';
import exportFromJSON from 'export-from-json'

export default {
    name: "InsuranceDocuments",
    props: {
        insuranceDocuments: {
            type: Array,
            default: []
        },
        name: {
            type: String,
            default: 'insurance_documents',
            required: false
        },
        actions: {
            type: Object,
            default: null,
            required: false
        },
        customField: {
            type: String,
            default: null,
            required: false
        },
        order: {
            type: String,
            default: 'default',
        },
        customFieldPosition: {
            type: String,
            default: 'start',
        },
        extraId: {
            default: null,
        },
        trCondition: {
            type: Function,
            default: null,
        },
    },

    components: {
        VueGoodTable,
    },
    data() {
        return {
            actionsLocal: {
                add: true,
                edit: true,
                reset: true,
                remove: true,
                columns: true,
                file: true,
            },
            columns: [],
            rows: [],
            ids: [],
            selecteds: [],
            contact_type_id: null,
            contact_types_selecteds: [],
            loading:true,
        };
    },
    mounted() {
        this.ids = this.insuranceDocuments;
        this.getInsuranceDocuments()
        if (this.actions !== null) {
            this.actionsLocal = Object.assign(this.actionsLocal, this.actions);
        }
    },
    methods: {
        tdClassFunc(row) {
            return this.trCondition(row);
        },
        toggleColumn(index, event) {
            this.$set(this.columns[index], 'hidden', !this.columns[index].hidden);
        },
        setStatusColumn(column) {
            column.hidden = !column.hidden;
            this.setColumnsStore()
        },
        async getInsuranceDocuments() {
            let app = this;
            let ids = this.ids.map(function (el, index) {
                return `ids[${index}]=${el}`
            }).join('&');
            await axios.get(`/insurance_documents/list-of-ids?${ids}&order=${this.order}`).then((response) => {
                app.columns = response.data.columns
                if (app.trCondition != null) {
                    app.columns = app.columns.map((e) => {
                        e.tdClass = app.tdClassFunc
                        return e;
                    })
                }
                app.rows = response.data.rows
                app.getColumnsStore()

                app.loading = false

            })
                .catch((err) => {
                    showMessage('e', 'Error loading insurance_documents');
                    console.error(err);
                })

            this.$root.addTypeButton();

        },
        setSelecteds(insurance_documents) {
            this.contact_types_selecteds = insurance_documents;
        },
        addInsuranceDocument() {
            this.ids = this.rows.map(function (el) {
                return el.id;
            })
            if (this.contact_types_selecteds.length) {
                for (let i = 0; i < this.contact_types_selecteds.length; i++) {
                    this.ids.push(this.contact_types_selecteds[i]);
                }
            }
            this.contact_types_selecteds = []
            this.getInsuranceDocuments()
            $('#insuranceDocumentsModal').modal('toggle');
        },
        addInsuranceDocumentId(id) {
            this.contact_type_id = id
        },
        removeInsuranceDocument() {
            let app = this;
            this.rows = this.rows.filter(function (item) {
                let deleted = false;
                for (let i = 0; i < app.selecteds.length; i++) {
                    if (app.selecteds[i].id === item.id) {
                        deleted = true;
                        break;
                    }
                }
                return !deleted
            })
        },
        selectionChanged(params) {
            // params.selectedRows - all rows that are selected (this page)
            this.selecteds = params.selectedRows
        },
        setColumnsStore() {
            localStorage.removeItem('contact_type_columns');
            let columns = this.columns.filter((col) => {
                return !col.hidden
            });
            localStorage.setItem('contact_type_columns', JSON.stringify(columns));
        },
        getColumnsStore() {
            let columns = localStorage.getItem('contact_type_columns');
            if (columns) {
                columns = JSON.parse(columns)
                this.columns = this.columns.map((col) => {
                    col.hidden = true;
                    for (let i = 0; i < columns.length; i++) {
                        if (columns[i].field === col.field) {
                            col.hidden = false;
                            break;
                        }
                    }
                    return col
                });

            }

            if (this.customField != null) {
                if (this.customFieldPosition === 'start')
                    this.columns.unshift({label: this.customField, field: 'custom_field',});
                else {
                    let lenghtColumn = this.columns.length - 1;
                    if (this.columns[lenghtColumn].field === 'actions') {
                        let lastColumn = this.columns[lenghtColumn];
                        this.columns[lenghtColumn] = {label: this.customField, field: 'custom_field'}
                        this.columns.push(lastColumn);
                    } else {
                        this.columns.push({label: this.customField, field: 'custom_field',});
                    }
                }
            }
        },
        removeColumnsStore() {
            localStorage.removeItem('contact_type_columns');
            this.getInsuranceDocuments()
        },
        exportExcel() {

            let data = [];
            let header = [];
            header = this.columns.filter((col) => {
                return !col.hidden;
            })

            data.push(header.map((h) => {
                return h.label
            }))

            let fields = header.map((_) => {
                return _.field;
            })

            this.rows.forEach((row) => {
                let r = [];
                for (let i = 0; i < fields.length; i++) {
                    r.push(row[fields[i]])
                }
                data.push(r)
            })

            const fileName = 'insurance_documents'
            const exportType = exportFromJSON.types.xls

            exportFromJSON({data, fileName, exportType})
        },

    }
}
</script>

<style>
.vgt-table td, .vgt-table th {
    padding: 2px !important;
    font-size: 12px;
}

#vgt-table {
    min-height: 100px;
}
</style>
